import './pages/PageCommon.css';
import React, {useState} from 'react';
import AppRoutes from "./AppRoutes";
import {AppContext, AppContextDefaults} from './AppContext';

function PelaajatComApp() {
    let [context, setContext] = useState(AppContextDefaults);
    if (context._contextSetup === false) {
        context.setContext = (newContext) => {
            //console.error('newContext=', JSON.parse(JSON.stringify(newContext)), 'context=', JSON.parse(JSON.stringify(context))); // DEBUG
            context = {...context, ...newContext};
            setContext(context);
        };
        context.updateContext = (key, value) => {
            let newData = {};
            newData[key] = value;
            context.setContext(newData);
        };
        delete context._contextSetup;
        setContext(context);
    }

    return (
        <React.StrictMode>
            <AppContext.Provider value={context}>
                <AppRoutes />
            </AppContext.Provider>
        </React.StrictMode>
    );
}

export default PelaajatComApp;
